const normalize = (value) => String(value ?? "")
  .normalize("NFD")
  .replace(/[\u0300-\u036f]/g, "")
  .replace(/[^a-zA-Z0-9]/g, "")
  .toUpperCase();

export function skuPriority(sku) {
  const normalized = normalize(sku);
  if (/^[A-Z]{1,4}\d{1,5}$/.test(normalized) && !/^ML\d+$/.test(normalized)) return 4;
  if (/^ML\d+$/.test(normalized)) return 1;
  if (/^\d{6,}$/.test(normalized)) return 0;
  return 2;
}

export function chooseCanonicalProduct(products) {
  const ranked = [...products].sort((a, b) => skuPriority(b.sku) - skuPriority(a.sku));
  if (ranked.length > 1 && skuPriority(ranked[0].sku) === skuPriority(ranked[1].sku)) return undefined;
  return ranked[0];
}

export function resolveVariant(inventory, aliases, skuText, colorText) {
  const sku = normalize(skuText);
  const color = normalize(colorText);
  const rowByVariant = new Map(inventory.map((row) => [row.variant.id, row]));
  const directAlias = aliases.find((alias) => alias.kind === "sku" && alias.normalizedAlias === sku);
  if (directAlias) {
    const row = rowByVariant.get(directAlias.variantId);
    return { productMatched: true, product: row?.product, row };
  }

  const products = Array.from(new Map(inventory.map((row) => [row.product.id, row.product])).values());
  const product = products
    .filter((item) => sku === normalize(item.sku) || sku.startsWith(normalize(item.sku)))
    .sort((a, b) => normalize(b.sku).length - normalize(a.sku).length)[0];
  if (!product) return { productMatched: false, product: undefined, row: undefined };

  const candidates = inventory.filter((row) => row.product.id === product.id);
  const productSku = normalize(product.sku);
  const remainder = sku.startsWith(productSku) ? sku.slice(productSku.length) : "";
  const candidateNames = [color, remainder].filter(Boolean);
  let row = candidates.find((item) => candidateNames.includes(normalize(item.variant.colorName)));
  if (!row) {
    const alias = aliases.find((item) => item.productId === product.id && candidateNames.includes(item.normalizedAlias));
    row = alias ? rowByVariant.get(alias.variantId) : undefined;
  }
  if (!row && remainder) {
    row = candidates
      .filter((item) => remainder.startsWith(normalize(item.variant.colorName)))
      .sort((a, b) => normalize(b.variant.colorName).length - normalize(a.variant.colorName).length)[0];
  }
  return { productMatched: true, product, row };
}
